import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const HOUSEHOLDPOPULATIONDENSITYACRESDIFFINVANY_LAYER_ID =
  'householdPopulationDensityAcresDiffInvAnyLayer';

const layerConfig = {
  title: 'Household Population Density Acres Difference',
};

function HouseholdPopulationDensityAcresDiffInvAnyLayer() {
  const dispatch = useDispatch();
  const { householdPopulationDensityAcresDiffInvAnyLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, householdPopulationDensityAcresDiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (householdPopulationDensityAcresDiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HOUSEHOLDPOPULATIONDENSITYACRESDIFFINVANY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: householdPopulationDensityAcresDiffInvAnyLayer.visible,
      opacity: householdPopulationDensityAcresDiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'household_population_density_acres_diff',
        domain: [-31, -20, -10, 0, 0.01, 1, 22],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HOUSEHOLDPOPULATIONDENSITYACRESDIFFINVANY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['household_population_density_acres_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default HouseholdPopulationDensityAcresDiffInvAnyLayer;
